import { makeStyles } from '@mui/styles';

export  const useStyles = makeStyles(theme => ({
    rootFileWithWidth: {
        minWidth: prop => prop?.width ? prop.width : '25%',
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: "flex-start",
        paddingRight: theme.spacing(2),
        marginTop: 30,
        '@media (max-width:1500px)':{
			width: '33%'
		},
        '@media (max-width:1400px)':{
			width: '37%'
		},
        '@media (max-width:1200px)':{
			width: '33%'
		},
        '@media (max-width:992px)':{
			width: '50%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '2.5%',
		},
		'@media (max-width:768px)':{
			width: '100%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '3.5%',
		},
    },
    errorMessagesFile: {
        marginTop: 10,
        color: '#ff1744',
        fontSize: 16,
        '@media (max-width:768px)':{
            fontSize: "15px",
		},
    },
    contenedorIcon: {
        marginRight: '5px',
    },
    nameOfFile: {
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '17px',
        fontWeight: 800,
        margin: "10px auto"
    }
}));
